module.exports = __webpack_public_path__ + "static/media/Ricongiungimento_saperedipiù.378d9027.png";